import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FormValidationModule } from '@tablesready/common-ui';
import { SignupByInviteComponent } from './signup-by-invite.component';
import { SignupByInviteRoutingModule } from './signup-by-invite-routing.module';
import { IonicModule } from '@ionic/angular';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';

@NgModule({
  declarations: [SignupByInviteComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SignupByInviteRoutingModule,
    FormValidationModule,
    IonicModule,
    AlertsModule,
  ],
  exports: [
    SignupByInviteComponent,
  ],
})
export class SignupByInviteModule {}
